<template>
  <div class="VioletBar"><slot></slot></div>
</template>
<script>
export default {
  name: "violet-bar"
};
</script>

<style lang="scss">
.VioletBar {
  background: #333;
  color: white;
  font-weight: 700;
  padding: 4px 1em;
}
</style>
